import { Stripe, PaymentRequest } from "@stripe/stripe-js";
import { Cart } from "../hooks/useUpdateCartMutation/useUpdateCartMutation";

export function getPaymentRequest(stripe: Stripe, cart: Cart) {
  return stripe.paymentRequest({
    country: cart.country,
    currency: cart.currency.toLowerCase(),
    total: {
      label: "Total",
      amount: cart.cartTotal * 100,
    },
    requestPayerName: true,
    requestPayerEmail: true,
    requestPayerPhone: true,
    disableWallets: ["link"],
    displayItems: [
      {
        label: "Neko Scan",
        amount: cart.cartTotal * 100,
      },
    ],
  });
}

export function getWallet(paymentRequest: PaymentRequest) {
  return paymentRequest.canMakePayment();
}
